import { Dayjs } from 'dayjs'

export const sortDate = (first: Dayjs, second: Dayjs) => {
    return second.isBefore(first) ? 1 : -1
}
